<script setup lang="ts">
import { ref } from 'vue';
import { useEquipmentInfo } from '/@entities/equipment/api/useEquipmentInfo';
import { ResourceEvent } from '/@types/resources';

const props = defineProps<{
  event: ResourceEvent;
}>();

const showEquipmentInfo = ref(false);

const { equipmentInfo, equipmentLoading } = useEquipmentInfo(() => props.event.resourceGuid);
</script>

<template>
  <div class="dl__group dl__group--large dl__group--actions" v-if="event.userName">
    <h2 class="dl__topic">Utstyr</h2>
    <p class="dl__description">{{ event.userName }}</p>
    <div class="dl__actions">
      <df-button v-on:click="showEquipmentInfo = !showEquipmentInfo" :active="showEquipmentInfo">
        <template v-slot:icon>
          <df-icon code="f05a" />
        </template>
      </df-button>
    </div>
  </div>

  <template v-if="showEquipmentInfo && equipmentLoading">
    <div class="dl__group dl__group--large dl__group--horizontal">
      <div class="dl__description">
        <div class="loading-icon"></div>
      </div>
    </div>
  </template>

  <template v-else-if="showEquipmentInfo">
    <template v-for="entry in equipmentInfo" :key="entry.label">
      <div class="dl__group dl__group--sub" :class="{ 'dl__group--large': entry.large }">
        <h2 class="dl__topic">{{ entry.label }}</h2>
        <p class="dl__description">{{ entry.value || '-' }}</p>
      </div>
    </template>
  </template>
</template>
